import React from 'react'
import DOMPurify from 'dompurify'
import HTMLReactParser from 'html-react-parser'
import { AnotacaoAtendimentoView } from '../../../atendimento/core/_models'
import { useAuth } from '../../../../auth'
import { AnotacaoType } from '../../../../../../_metronic/helpers'
import { temVinculoMedico } from 'app/modules/auth/core/vinculos'

interface AnnotationProps {
  nota: AnotacaoAtendimentoView
}

const Anotacao: React.FC<AnnotationProps> = ({ nota }) => {
  const { currentUser } = useAuth()
  const isMedico = temVinculoMedico(currentUser?.vinculos)

  if (nota.tipo === 'ANAMNESE' && !isMedico) {
    return <></>
  }

  // Réplica do solicitante (interconsulta): texto puro, em destaque.
  if (nota.tipo === AnotacaoType.Replica) {
    return (
      <li>
        <strong>Réplica do solicitante</strong>
        {nota.dataFormatada && ` (${nota.dataFormatada})`}
        {' - '}
        <span style={{ whiteSpace: 'pre-wrap' }}>{nota.anotacao}</span>
      </li>
    )
  }

  return (
    <li>
      {nota.tipo}
      {' - '}
      {HTMLReactParser(DOMPurify.sanitize(nota.anotacao as string))}
    </li>
  )
}

export default Anotacao
